





























































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import RadioInlineGroup from '@/components/RadioInlineGroup.vue'
import {
  EPaymentMethodType,
  EResidentPaymentMethodAccountType,
  EUserPermissions, IFacility,
  IPaymentsFiltersDTO,
  US_STATES_LIST,
} from '@zunta/configurations'
import { HmoModule } from '@/store/modules/hmo.module'
import { FacilityModule } from '@/store/modules/facility.module'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { mapGetters } from 'vuex'
import { PaymentsModule } from '@/store/modules/payments.module'
import { ZIP_MASK } from '@/constants'
import RadioButton from '@/components/RadioButton.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import InputMoney from '@/components/inputsV2/InputMoney.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'
import { minLength, minValue, required, requiredIf } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { makeProcessingNotificationTimeout } from '@/utils/helpers'
import { cardNumberOptions } from '@/utils/payment'

const luhn = require('luhn')

const isExpirationValid = (value: any) => {
  // get current year and month
  const d = new Date()
  const currentYear = d.getFullYear()
  const currentMonth = d.getMonth() + 1
  // get parts of the expiration date
  const parts = value.split('/')
  const year = parseInt(parts[1], 10) + 2000
  const month = parseInt(parts[0], 10)
  // compare the dates
  return !(year < currentYear || (year === currentYear && month < currentMonth))
}

@Component({
  components: {
    InputValidator,
    TextareaV2,
    ModalV2,
    InputV2,
    InputMoney,
    SelectV2,
    RadioButton,
    Icon,
    RadioInlineGroup
  },
  computed: {
    ...mapGetters({
      filters: 'payments/getFilters'
    })
  }
})
export default class AddHMOPaymentModal extends Vue {
  user: User = Api.getUser() as User
  EPaymentMethodType: any = EPaymentMethodType
  EUserPermissions: any = EUserPermissions
  ZIP_MASK: any = ZIP_MASK
  cardNumberOptions = cardNumberOptions
  hmoModuleInstance: HmoModule = getModule(HmoModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  selectedFacility: IFacility | null = null

  type: string = EPaymentMethodType.CREDIT_CARD
  paymentMethodData = {
    paymentMethodName: '',
    echeckAccountType: EResidentPaymentMethodAccountType.CHECKING,
    securityCode: '',
    cardNumber: '',
    expiration: '',
    echeckRoutingNumber: '',
    echeckAccountNumber: ''
  }
  filters!: IPaymentsFiltersDTO
  isTransiting: boolean = false
  isLoading: boolean = false
  isEdit: boolean = false
  isRoutingValid: boolean = true

  payment: any = {
    customAddress: {
      useCustomAddress: false,
      state: '',
      city: '',
      zip: '',
      address: ''
    }
  }

  hmoDefaultAddress: any = {
    state: '',
    city: '',
    zip: '',
    address: ''
  }

  validations (): any {
    return {
      payment: {
        hmoId: {
          required
        },
        facilityId: {
          required
        },
        amount: {
          required,
          positive: minValue(0.01)
        },
        customAddress: {
          address: {
            required: requiredIf(() => this.payment.customAddress.useCustomAddress)
          },
          state: {
            required: requiredIf(() => this.payment.customAddress.useCustomAddress)
          },
          city: {
            required: requiredIf(() => this.payment.customAddress.useCustomAddress)
          },
          zip: {
            minLength: minLength(5),
            required: requiredIf(() => this.payment.customAddress.useCustomAddress)
          }
        }
      },
      paymentMethodData: {
        paymentMethodName: {
          required,
        },
        // cc validation
        cardNumber: {
          required: requiredIf(() => this.isCC),
          validCC: (value: any) => !value || ((cardNumberOptions(this.isAmericanExpressCard, 'length', true) as RegExp).test((value || '').replace(/\s/g, '')) && luhn.validate(value))
        },
        securityCode: {
          valid: (value: any) => !value || (cardNumberOptions(this.isAmericanExpressCard, 'CVC', true) as RegExp).test(value)
          // minLength: minLength(3)
        },
        expiration: {
          required: requiredIf(() => this.isCC),
          valid: (value: any) => !value || (isExpirationValid(value) && /^\d{2}\/(\d{2}|\d{4})$/.test(value))
        },
        // eCheck validation
        echeckRoutingNumber: {
          required: requiredIf(() => this.isECheck),
          minLength: minLength(9),
          valid: (value: any) => !value || this.isRoutingValid
        },
        echeckAccountNumber: {
          required: requiredIf(() => this.isECheck)
        }
      }
    }
  }

  get stateList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      key: stateShortName,
      value: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  get transitionClasses () {
    if (this.type === EPaymentMethodType.ECHECK) {
      return {
        in: 'fadeInRight',
        out: 'fadeOutLeft'
      }
    }
    return {
      in: 'fadeInLeft',
      out: 'fadeOutRight'
    }
  }

  get transitionClassesAddress () {
    return {
      in: 'fadeInDown',
      out: 'fadeOutUp'
    }
  }

  get facilities () {
    return this.$store.state.facility.facilities
  }

  get hmos () {
    return this.$store.state.hmo.hmos
  }

  get facilitiesList () {
    const hmo = this.hmos.find((hmo: any) => hmo.id === this.payment.hmoId)
    if (!hmo) {
      return []
    }

    const facilities = hmo.isAllFacilities
      ? this.facilities
      : this.facilities.filter(
        (facility: any) => hmo.facilities
          .map((f: any) => Number(f))
          .includes(facility.id)
      )

    return facilities.map((facility: any) => ({
      key: facility.id,
      value: facility.id,
      content: facility.name
    }))
  }

  get hmoList () {
    return this.hmos.map((hmo: any) => ({
      key: hmo.id,
      value: hmo.id,
      content: hmo.name
    }))
  }

  get echeckAccountTypeItemsList () {
    return Object.values(EResidentPaymentMethodAccountType).map((accountType: string) => {
      return {
        value: accountType,
        key: accountType,
        content: accountType
      }
    })
  }

  get cardIcon () {
    if (this.isVisaCard) {
      return 'visa'
    }
    if (this.isMasterCard) {
      return 'mastercard'
    }
    if (this.isAmericanExpressCard) {
      return 'amex'
    }
    if (this.isDiscoverCard) {
      return 'discover'
    }
    return ''
  }

  get isVisaCard () {
    if (!this.paymentMethodData.cardNumber) {
      return false
    }
    return /^4/.test(this.paymentMethodData.cardNumber.replace(/\s/g, ''))
  }

  get isMasterCard () {
    if (!this.paymentMethodData.cardNumber) {
      return false
    }
    return /^5/.test(this.paymentMethodData.cardNumber.replace(/\s/g, ''))
  }

  get isAmericanExpressCard () {
    if (!this.paymentMethodData.cardNumber) {
      return false
    }
    return /^3/.test(this.paymentMethodData.cardNumber.replace(/\s/g, ''))
  }

  get isDiscoverCard () {
    if (!this.paymentMethodData.cardNumber) {
      return false
    }
    return /^6/.test(this.paymentMethodData.cardNumber.replace(/\s/g, ''))
  }

  get paymentMethodTypes () {
    const types = [
      {
        value: EPaymentMethodType.CREDIT_CARD,
        key: 'credit',
        content: 'Credit Card'
      },
      {
        value: EPaymentMethodType.ECHECK,
        key: 'echeck',
        content: 'eCheck'
      }
    ]
    return types
  }

  get ccDisabled () {
    return this.selectedFacility && !this.selectedFacility.allowCCProcessing
  }

  async mounted () {
    await Promise.all([
      this.hmoModuleInstance.getHmoList({}),
      this.facilityModuleInstance.getFacilityList({})
    ])
  }

  setCustomAddress (value: boolean) {
    this.payment.customAddress.useCustomAddress = value
    this.payment.customAddress.state = ''
    this.payment.customAddress.city = ''
    this.payment.customAddress.zip = ''
    this.payment.customAddress.address = ''
  }

  setIsTransiting (value: boolean) {
    this.isTransiting = value
  }

  openAddHMOModal () {
    this.$emit('openAddHmoModal')
  }

  selectHmo (value: any): void {
    const hmo = this.hmos.find((hmo: any) => hmo.id === value)
    this.hmoDefaultAddress = {
      state: hmo.state,
      city: hmo.city,
      zip: hmo.zip,
      address: hmo.address
    }
    this.payment.customAddress = {
      useCustomAddress: this.payment.customAddress.useCustomAddress,
      state: hmo.state,
      city: hmo.city,
      zip: hmo.zip,
      address: hmo.address
    }
    this.paymentMethodData.paymentMethodName = hmo.name
  }

  get isCC () {
    return this.type === EPaymentMethodType.CREDIT_CARD
  }

  get isECheck () {
    return this.type === EPaymentMethodType.ECHECK
  }

  changePaymentMethod (value: any) {
    this.type = value
    this.$v.$reset()
  }

  async addHMOPayment (): Promise<void> {
    this.$v.$touch()
    if (this.isECheck) {
      if (!this.paymentMethodData.echeckRoutingNumber) {
        return
      }
      this.isLoading = true
      const banks = await this.paymentsModuleInstance.getBanks({ routing: this.paymentMethodData.echeckRoutingNumber })
      if ((!banks || !banks.length)) {
        this.isRoutingValid = false
        this.isLoading = false
        return
      }
      this.isRoutingValid = true
    }
    if (this.$v.$anyError) {
      this.isLoading = false
      return
    }
    this.payment.paymentMethodData = this.paymentMethodData
    this.payment.paymentMethodData.cardNumber = this.paymentMethodData.cardNumber.replace(/\s/g, '')
    this.payment.paymentMethodType = this.type
    this.isLoading = true
    const timeout = makeProcessingNotificationTimeout(this, `Please don't refresh. Transaction is still processing.`, 3000)
    const res = await this.residentModuleModuleInstance.makeHMOPayment({
      facilityId: this.payment.facilityId,
      data: this.payment
    })
    await this.paymentsModuleInstance.getPaymentsList(this.filters)
    clearTimeout(timeout)
    this.isLoading = false
    if (res.status !== 'Failed') {
      if (res.payment) {
        this.$router.push({ name: 'hmo-payment-approved', params: { id: res.payment.id } })
      }
    } else {
      if (!res.payment) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: res.message.join('\n'),
          header: 'Make Payment',
          icon: 'warning'
        })
        return
      }
      await this.$router.push({ name: 'hmo-payment-declined', params: { id: res.payment.id } })
    }
  }

  selectFacility (event: number) {
    if (event) {
      this.selectedFacility = this.facilities.find((f: IFacility) => f.id === event)
      if (this.ccDisabled) {
        this.type = EPaymentMethodType.ECHECK
      }
    } else {
      this.selectedFacility = null
    }
  }
}
